const apiUrl = process.env.REACT_APP_API_URL;

export const ReorderActivitats = async (ids: string[]) => {
    try {
        await fetch(`${apiUrl}:8061/jutge/activitats/reorder`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(ids)
            });
        return true;
    } catch (error) {
        console.log('Error al reordenar las actividades:', error);
        return false;
    }
};
